import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CreateFormAuditDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formAuditApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM_AUDIT = "CREATE_FORM_AUDIT";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

type CreateFormAuditRequest = CreateFormAuditDto;

const createFormAudit = async (req: CreateFormAuditRequest): Promise<void> => {
  const response = await formAuditApi.formAuditControllerCreateFormAudit(req);

  return response.data;
};

export const useCreateFormAudit = (
  user: UserProfileDto | null,
): {
  createFormAudit: UseMutateFunction<void, Error, CreateFormAuditRequest, unknown>;
  createFormAuditEnabled: boolean;
  isSuccessCreateFormAudit: boolean;
  isPendingCreateFormAudit: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS, ACTION_CREATE_FORM_AUDIT],
    mutationFn: enabled ? createFormAudit : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    createFormAudit: mutate,
    createFormAuditEnabled: enabled,
    isSuccessCreateFormAudit: isSuccess,
    isPendingCreateFormAudit: isPending,
  };
};
